/* tslint:disable */
/* eslint-disable */
/**
 * Flawtrack Backend
 * Flawtrack ASM
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FindingSeverityEnum } from './FindingSeverityEnum';
import {
    FindingSeverityEnumFromJSON,
    FindingSeverityEnumFromJSONTyped,
    FindingSeverityEnumToJSON,
    FindingSeverityEnumToJSONTyped,
} from './FindingSeverityEnum';
import type { Status111Enum } from './Status111Enum';
import {
    Status111EnumFromJSON,
    Status111EnumFromJSONTyped,
    Status111EnumToJSON,
    Status111EnumToJSONTyped,
} from './Status111Enum';
import type { FindingEvidence } from './FindingEvidence';
import {
    FindingEvidenceFromJSON,
    FindingEvidenceFromJSONTyped,
    FindingEvidenceToJSON,
    FindingEvidenceToJSONTyped,
} from './FindingEvidence';
import type { LogEntry } from './LogEntry';
import {
    LogEntryFromJSON,
    LogEntryFromJSONTyped,
    LogEntryToJSON,
    LogEntryToJSONTyped,
} from './LogEntry';

/**
 * 
 * @export
 * @interface Finding
 */
export interface Finding {
    /**
     * 
     * @type {number}
     * @memberof Finding
     */
    readonly id: number;
    /**
     * 
     * @type {string}
     * @memberof Finding
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof Finding
     */
    overview?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Finding
     */
    endpoint?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Finding
     */
    details?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Finding
     */
    stepsToReproduce?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Finding
     */
    impact?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Finding
     */
    remediationSteps?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Finding
     */
    additionalNotes?: string | null;
    /**
     * 
     * @type {any}
     * @memberof Finding
     */
    references?: any | null;
    /**
     * 
     * @type {any}
     * @memberof Finding
     */
    rawInfo: any | null;
    /**
     * 
     * @type {any}
     * @memberof Finding
     */
    classification: any | null;
    /**
     * 
     * @type {any}
     * @memberof Finding
     */
    metadata: any | null;
    /**
     * 
     * @type {any}
     * @memberof Finding
     */
    authors: any | null;
    /**
     * 
     * @type {any}
     * @memberof Finding
     */
    tags: any | null;
    /**
     * 
     * @type {FindingSeverityEnum}
     * @memberof Finding
     */
    severity: FindingSeverityEnum;
    /**
     * 
     * @type {number}
     * @memberof Finding
     */
    exploitabilityRate?: number;
    /**
     * 
     * @type {string}
     * @memberof Finding
     */
    cve?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Finding
     */
    cvssScore?: string | null;
    /**
     * 
     * @type {Status111Enum}
     * @memberof Finding
     */
    status?: Status111Enum;
    /**
     * 
     * @type {number}
     * @memberof Finding
     */
    assetType?: number | null;
    /**
     * 
     * @type {number}
     * @memberof Finding
     */
    assetId?: number;
    /**
     * 
     * @type {string}
     * @memberof Finding
     */
    readonly assetTypeName: string;
    /**
     * 
     * @type {string}
     * @memberof Finding
     */
    readonly assetName: string;
    /**
     * 
     * @type {Date}
     * @memberof Finding
     */
    readonly createdAt: Date;
    /**
     * 
     * @type {Array<FindingEvidence>}
     * @memberof Finding
     */
    readonly evidences: Array<FindingEvidence>;
    /**
     * 
     * @type {Date}
     * @memberof Finding
     */
    readonly updatedAt: Date;
    /**
     * 
     * @type {number}
     * @memberof Finding
     */
    assignedTo?: number | null;
    /**
     * 
     * @type {Array<LogEntry>}
     * @memberof Finding
     */
    readonly history: Array<LogEntry>;
    /**
     * 
     * @type {string}
     * @memberof Finding
     */
    component?: string | null;
}



/**
 * Check if a given object implements the Finding interface.
 */
export function instanceOfFinding(value: object): value is Finding {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('rawInfo' in value) || value['rawInfo'] === undefined) return false;
    if (!('classification' in value) || value['classification'] === undefined) return false;
    if (!('metadata' in value) || value['metadata'] === undefined) return false;
    if (!('authors' in value) || value['authors'] === undefined) return false;
    if (!('tags' in value) || value['tags'] === undefined) return false;
    if (!('severity' in value) || value['severity'] === undefined) return false;
    if (!('assetTypeName' in value) || value['assetTypeName'] === undefined) return false;
    if (!('assetName' in value) || value['assetName'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('evidences' in value) || value['evidences'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('history' in value) || value['history'] === undefined) return false;
    return true;
}

export function FindingFromJSON(json: any): Finding {
    return FindingFromJSONTyped(json, false);
}

export function FindingFromJSONTyped(json: any, ignoreDiscriminator: boolean): Finding {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'title': json['title'],
        'overview': json['overview'] == null ? undefined : json['overview'],
        'endpoint': json['endpoint'] == null ? undefined : json['endpoint'],
        'details': json['details'] == null ? undefined : json['details'],
        'stepsToReproduce': json['steps_to_reproduce'] == null ? undefined : json['steps_to_reproduce'],
        'impact': json['impact'] == null ? undefined : json['impact'],
        'remediationSteps': json['remediation_steps'] == null ? undefined : json['remediation_steps'],
        'additionalNotes': json['additional_notes'] == null ? undefined : json['additional_notes'],
        'references': json['references'] == null ? undefined : json['references'],
        'rawInfo': json['raw_info'],
        'classification': json['classification'],
        'metadata': json['metadata'],
        'authors': json['authors'],
        'tags': json['tags'],
        'severity': FindingSeverityEnumFromJSON(json['severity']),
        'exploitabilityRate': json['exploitability_rate'] == null ? undefined : json['exploitability_rate'],
        'cve': json['cve'] == null ? undefined : json['cve'],
        'cvssScore': json['cvss_score'] == null ? undefined : json['cvss_score'],
        'status': json['status'] == null ? undefined : Status111EnumFromJSON(json['status']),
        'assetType': json['asset_type'] == null ? undefined : json['asset_type'],
        'assetId': json['asset_id'] == null ? undefined : json['asset_id'],
        'assetTypeName': json['asset_type_name'],
        'assetName': json['asset_name'],
        'createdAt': (new Date(json['created_at'])),
        'evidences': ((json['evidences'] as Array<any>).map(FindingEvidenceFromJSON)),
        'updatedAt': (new Date(json['updated_at'])),
        'assignedTo': json['assigned_to'] == null ? undefined : json['assigned_to'],
        'history': ((json['history'] as Array<any>).map(LogEntryFromJSON)),
        'component': json['component'] == null ? undefined : json['component'],
    };
}

  export function FindingToJSON(json: any): Finding {
      return FindingToJSONTyped(json, false);
  }

  export function FindingToJSONTyped(value?: Omit<Finding, 'id'|'asset_type_name'|'asset_name'|'created_at'|'evidences'|'updated_at'|'history'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'title': value['title'],
        'overview': value['overview'],
        'endpoint': value['endpoint'],
        'details': value['details'],
        'steps_to_reproduce': value['stepsToReproduce'],
        'impact': value['impact'],
        'remediation_steps': value['remediationSteps'],
        'additional_notes': value['additionalNotes'],
        'references': value['references'],
        'raw_info': value['rawInfo'],
        'classification': value['classification'],
        'metadata': value['metadata'],
        'authors': value['authors'],
        'tags': value['tags'],
        'severity': FindingSeverityEnumToJSON(value['severity']),
        'exploitability_rate': value['exploitabilityRate'],
        'cve': value['cve'],
        'cvss_score': value['cvssScore'],
        'status': Status111EnumToJSON(value['status']),
        'asset_type': value['assetType'],
        'asset_id': value['assetId'],
        'assigned_to': value['assignedTo'],
        'component': value['component'],
    };
}

